import { Card as HeroCard } from '@heroui/react'
import { type ReactNode } from 'react'

/**
 * Every data view lives in a card (or a tile). The card owns all spacing and
 * the border; a chart, a table or a funnel inside it brings none of its own.
 */
const Card = ({ children }: { children: ReactNode }) => (
  <HeroCard className="grid min-w-0 gap-4 rounded-xl p-5">{children}</HeroCard>
)

export default Card
